document.addEventListener('DOMContentLoaded', function () {
    const section_ID = document.getElementsByClassName('product-info-wrap')[0].id.replaceAll('shopify-section-', '');
    const urlParams = new URLSearchParams(window.location.search);
    const idx = localStorage.getItem('idx');
    const ID = localStorage.getItem('vID');
    let vFit = "{{ product.selected_or_first_available_variant.metafields.tyre_spec.size_full }}"
    let reqString = `${url}/fitments/${ID}?subscription-key=${key}`;
    const options = { method: 'GET' };
  if(!reqString.includes('null')) {
    splitLabeller(reqString, options, idx, false)

    document.getElementById(`Option-${section_ID}-0`).addEventListener('change', function () {
        splitLabeller(reqString, options, idx, true);
    });

    document.getElementById(`Option-${section_ID}-1`).addEventListener('change', function () {
        splitLabeller(reqString, options, idx, true);
    });
  }
    async function splitLabeller(X, Y, Z, A) {
        if (A) {
            let secondSelect = document.getElementById(`Option-${section_ID}-1`);
            let vIndex = secondSelect.value.split(' ', 2).join(' ').length;
            if (secondSelect.value.length > vIndex) {
                vFit = `${document.getElementById(`Option-${section_ID}-0`).value} ${secondSelect.value.substring(0, vIndex).replace(' ', '')}`;
            } else {
                vFit = `${document.getElementById(`Option-${section_ID}-0`).value} ${secondSelect.value.replace(' ', '')}`;
            }
        }
        let resp = localStorage.getItem(`fitment${ID}`);
        if (resp) {
            ans = await JSON.parse(resp);
        } else {
            resp = await fetch(X, Y);
            ans = await resp.json();
        }
        let wheel = 'all';
        if (ans.fitments[Z].f_tyres.full_desc != ans.fitments[Z].r_tyres.full_desc) {
            if (ans.fitments[Z].f_tyres.matches.includes(vFit)) {
                wheel = 'the front';
            } else if (ans.fitments[Z].r_tyres.matches.includes(vFit)) {
                wheel = 'the rear';
            }
            document.getElementById('splitBanner').innerHTML = `<h4 class="product-info-details-title h5 splitBanner" id="splitBanner">Suitable for ${wheel} wheels of your car</h4>`
        }
    }
});